import {
  useApiAdmintypologiesGetCollection,
  getApiAdmintypologiesGetCollectionQueryKey
} from '@r/api/generated/client.ts';
import { useTranslation } from 'react-i18next';
import { useOrvalQueryErrorToast } from '@r/hooks/use-orval-error-toast.ts';

export const useTypology = () => {
  const { t } = useTranslation();
  const typologiesQuery = useApiAdmintypologiesGetCollection(undefined, {
    query: {
      queryKey: getApiAdmintypologiesGetCollectionQueryKey()
    }
  });
  useOrvalQueryErrorToast(typologiesQuery, t('toast.error.label'));

  const {
    data: typologiesResponse,
    isLoading: isTypologiesLoading,
    isSuccess: isTypologiesSuccess,
    refetch: refetchTypologies
  } = typologiesQuery;

  return {
    typologies: typologiesResponse,
    isTypologiesLoading,
    isTypologiesSuccess,
    refetchTypologies
  };
};
